import React from "react";
import ReactDOM from "react-dom";
import App from "@data-force/app";
import {Route} from "react-router";
import {Modal} from "antd";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {actionWatcher as addTranslationSagaActionWatcher} from "./store/sagas/antdTranslation";
import antdTranslationReducer from "./store/reducers/antdTranslation";
import "./index.scss";
import MainView from "./pages/MainView/MainView";
import MarkdownPreview from "./components/MarkdownPreview/MarkdownPreview";
import {mainSagaActionWatcher} from "./store/sagas/main";
import jobReducer from "./store/reducers/job";
import testReducer from "./store/reducers/test";
import {jobSagaActionWatcher} from "./store/sagas/job";
import homeReducer from "./store/reducers/home";
import {homeSagaActionWatcher} from "./store/sagas/home";
import taskReducer from "./store/reducers/task";
import {taskSagaActionWatcher} from "./store/sagas/task";
import faqReducer from "./store/reducers/faq";
import {faqSagaActionWatcher} from "./store/sagas/faq";
import maskReducer from "./store/reducers/mask";
import mobileReducer from "./store/reducers/mobile";
import "./assets/fonts";
import "./assets/dayjs-locales";
import {Codes409, Codes412} from "./enums/enums";

const confirmDialogConfig: Object = {
    className: "df-dialog-confirm",
    icon: <ExclamationCircleOutlined aria-hidden/>,
    centered: true,
    okCancel: false,
};

ReactDOM.render(
    <App
        sagasToFork={[
            mainSagaActionWatcher,
            addTranslationSagaActionWatcher,
            homeSagaActionWatcher,
            jobSagaActionWatcher,
            taskSagaActionWatcher,
            faqSagaActionWatcher,
        ]}
        reducers={{
            antdTranslation: antdTranslationReducer,
            job: jobReducer,
            test: testReducer,
            task: taskReducer,
            home: homeReducer,
            faq: faqReducer,
            mask: maskReducer,
            mobile: mobileReducer,
        }}
        axiosErrors={{
            500: {
                dialog: Modal.error,
                customOkText: true,
            },
            502: {
                dialog: Modal.error,
            },
            503: {
                dialog: Modal.error,
            },
            409: {
                dialog: Modal.confirm,
                customOkText: true,
                dialogConfig: confirmDialogConfig,

                codes: [{
                    name: Codes409.POOL_CLAIM_LIMIT,
                    dialog: Modal.confirm,
                    customOkText: true,
                    dialogConfig: confirmDialogConfig,
                }, {
                    name: Codes409.POOL_ONGOING_LIMIT,
                    dialog: Modal.confirm,
                    customOkText: true,
                    dialogConfig: confirmDialogConfig,
                }],
            },
            412: {
                dialog: Modal.error,

                codes: [{
                    name: Codes412.NOT_READY,
                    dialog: Modal.error,
                    customOkText: true,
                    dialogConfig: {
                        className: "df-dialog-error",
                        centered: true,
                    },
                }],
            },
            415: {
                dialog: Modal.error,
            },
            422: {
                dialog: Modal.confirm,
                dialogConfig: confirmDialogConfig,
            },
            429: {
                dialog: Modal.confirm,
                customOkText: true,
                customCancelText: true,
                dialogConfig: {
                    icon: "close-circle",
                    cancelButtonProps: {
                        type: "primary",
                    },
                },
            },
        }}
    >
        <Route path="/tpa/markupTemplateChecker" exact component={MarkdownPreview}/>
        <Route path="/" component={MainView}/>
    </App>,
    document.getElementById("root"),
);
